module.exports = __webpack_public_path__ + "static/media/icon_folder_darkgrey.c6658c8f.svg";